import React from 'react';
import ArticleHeaderSkeleton from 'components/general/ArticleHeader/ArticleHeaderSkeleton';
import SkeletonParagraph from 'components/general/Skeleton/SkeletonParagraph';

const ArticleSkeleton: React.SFC = () => (
  <div className="article">
    <div className="article__content">
      <div className="article__header">
        <ArticleHeaderSkeleton />
      </div>
      <div className="article__body" itemProp="articleBody">
        <div className="article__meta">
          <SkeletonParagraph lines={2} />
          <SkeletonParagraph lines={2} />
          <SkeletonParagraph lines={2} />
        </div>
        <SkeletonParagraph lines={6} />
        <SkeletonParagraph lines={6} />
        <SkeletonParagraph lines={6} />
      </div>
    </div>
  </div>
);

export default ArticleSkeleton;
